import { bool, string } from 'prop-types'

Targa.propTypes = {
  targa: string,
  italiana: bool,
}

export default function Targa(props) {
  const {
    targa,
    italiana = true
  } = props

  return (
    <div className='targa-box'>
      <span
        title={italiana ? 'Targa italiana' : 'Targa straniera'}
        className={`${italiana ? 'targa-italiana' : 'targa-straniera'}`}
      >
        <span className='nazione'>{italiana ? 'I' : 'S'}</span>
        <span className='targa card-value'>{targa}</span>
      </span>
    </div>
  )
}